import PropTypes from 'prop-types';
import React from 'react';
import { defineMessages } from 'react-intl';

import { ILLUSTRATIONS } from 'constants/icons';
import LINKS from 'constants/links';
import { reactHookFormPropTypes } from 'constants/propTypes';
import { bem } from 'helpers/class-name';
import { messages as minimumSpotsMessages } from './MinimumSpots';
import { getPeakTimeMessage } from './SmartTools.helpers';
import { messages as peakTimeMessages } from './PeakTimeDefinition';
import SmartSpotOnboarding from './SmartSpotOnboarding';
import MinimumSpotsItem from './MinimumSpotsItem';

const messages = defineMessages({
  doneButton: {
    id: 'smart-spot-onboarding.minimum-spots.done-button',
    defaultMessage: 'Done',
  },
});

const { element } = bem('smart-spot-onboarding-minimum-spots');

const SmartSpotOnboardingMinimumSpots = ({
  control,
  countryCode = 'USA',
  handleLearnMore,
  onSkip,
  onNext,
  isSubmitting = false,
  isDoneDisabled = false,
  showSelectOptionPeakTime,
  showSelectOptionOffPeakTime,
}) => {
  const peakTimeMessage = getPeakTimeMessage(countryCode, peakTimeMessages);
  return (
    <SmartSpotOnboarding
      title={minimumSpotsMessages.title}
      description={minimumSpotsMessages.description}
      settingDetail={minimumSpotsMessages.settingDetail}
      countryCode={countryCode}
      learnMoreLink={LINKS.smartspot.learnMore}
      handleLearnMore={handleLearnMore}
      learnMoreLocation="minimum_spots"
      illustration={ILLUSTRATIONS.pilates}
      showLearnMorePeakTimes
      nextButton={messages.doneButton}
      onSkip={onSkip}
      onNext={onNext}
      isSubmitting={isSubmitting}
      nextButtonDisabled={isDoneDisabled}>
      <div className={element('content-group')}>
        <MinimumSpotsItem
          className={element('minimum-spots-item')}
          control={control}
          label={minimumSpotsMessages.peak}
          info={minimumSpotsMessages.peakInfo}
          schedule={peakTimeMessage}
          name="minimumSpotsPeakTime"
          showSelectOption={showSelectOptionPeakTime}
        />
        <MinimumSpotsItem
          className={element('minimum-spots-item')}
          control={control}
          label={minimumSpotsMessages.offPeak}
          info={minimumSpotsMessages.offPeakInfo}
          schedule={peakTimeMessages.offPeakTime}
          name="minimumSpotsOffpeakTime"
          showSelectOption={showSelectOptionOffPeakTime}
        />
      </div>
    </SmartSpotOnboarding>
  );
};

SmartSpotOnboardingMinimumSpots.propTypes = {
  control: reactHookFormPropTypes.control.isRequired,
  countryCode: PropTypes.string,
  handleLearnMore: PropTypes.func.isRequired,
  onSkip: PropTypes.func,
  onNext: PropTypes.func,
  isSubmitting: PropTypes.bool,
  isDoneDisabled: PropTypes.bool,
  showSelectOptionPeakTime: PropTypes.bool.isRequired,
  showSelectOptionOffPeakTime: PropTypes.bool.isRequired,
};

export default SmartSpotOnboardingMinimumSpots;
